import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalStateService {

  public user: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public canDisplay: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public themeMode: BehaviorSubject<string> = new BehaviorSubject('');
  public countries: BehaviorSubject<[]> = new BehaviorSubject([]);
  public setting: BehaviorSubject<any> = new BehaviorSubject(undefined);

  public baseUrl = environment.apiUrl;
  public websiteURL = environment.websiteURL

  constructor(private _localStorageService: LocalStorageService, private _http: HttpClient) {
    this.InitTheme();
    // Don't automatically get user on initialization
    // This will be handled by AuthInitializationService
    this.canDisplay.next(true);
  }

  public InitTheme() {
    let themeMode = this._localStorageService.Get('theme_color');
    if (!themeMode) this._localStorageService.Set('theme_color', themeMode || 'light', false);
    this.themeMode.next(themeMode || 'light');
  }

  public SetCountries() {
    const url = `${this.baseUrl}/general/countries?paginate=false`;
    this._http.get<any>(url).subscribe(data => {
      this.countries.next(data.data);
    });
  }

  public GetCountries() {
    return this.countries.asObservable();
  }

  public SetSetting() {
    const url = `${this.baseUrl}/settings`;
    this._http.get<any>(url).subscribe(data => {
      this.setting.next(data.data);
    });
  }

  public GetSetting() {
    return this.setting.asObservable();
  }

  public SetThemeMode(mode: string) {
    switch (mode) {
      case 'dark':
        this._localStorageService.Set('theme_color', mode, false)
        this.themeMode.next(mode);
        break;
      default:
        this._localStorageService.Set('theme_color', 'light', false)
        this.themeMode.next('light');
        break;
    }
  }

  public GetUser() {
    let user = this._localStorageService.Get('user');
    if (user) {
      this.user.next(JSON.parse(user))
      this.isLoggedIn.next(true)
    }
  }

  public SetUser(user: any) {
    this._localStorageService.Set('user', user, true)
    if (user.token)
      localStorage.setItem('authToken', user.token)
    localStorage.setItem('user_id', user._id)
    this.user.next(user)
    this.isLoggedIn.next(true)
  }

  /**
   * Set user login state without storing user data in localStorage
   * Only stores the token in localStorage as requested
   */
  public SetLoginState(userData: any, token: string) {
    // Store only the token in localStorage
    localStorage.setItem('authToken', token);

    // Store user ID if available (for reference)
    if (userData._id) {
      localStorage.setItem('user_id', userData._id);
    }

    // Update global state with user data (in memory only)
    this.user.next(userData);
    this.isLoggedIn.next(true);
  }

  /**
   * Clear user authentication state
   */
  public ClearAuthState(): void {
    this.user.next(undefined);
    this.isLoggedIn.next(false);
  }

  public GetBaseEndpoint(type = 'base') {
    switch (type) {
      case 'base':
        return this.baseUrl;
      case 'website':
        return this.websiteURL;
      default:
        return this.baseUrl;
    }
  }
}
